import React, { useState } from 'react'
import Button from '@components/Button'
import Radio from '@components/Radio'
import { Dropdown } from '@components/Autocomplete'

const formats = ['standard', 'Bain', 'BCG' ,'BCG XPRT Tool', 'PWC']

const EplExportModal = ({ noSelectedEpls, onOk, onCancel }) => {
  const [format, setFormat] = useState('standard')
  const [exportAll, setExportAll] = useState(!noSelectedEpls)
  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Export EPL</h2>
      <div style={{ marginBottom: 15 }}>
        {Boolean(noSelectedEpls) ? (
          <div>
            <div
              className="radio-button-input"
              style={{ marginRight: 10 }}
              onClick={() => setExportAll(false)}>
              <Radio checked={!exportAll} />
              <label>
                Export <strong>{noSelectedEpls}</strong> selected expert.
              </label>
            </div>
            <div
              className="radio-button-input"
              onClick={() => setExportAll(true)}>
              <Radio checked={exportAll} />
              <label>Export all experts.</label>
            </div>
          </div>
        ) : (
          <div>You are going to export all experts</div>
        )}
      </div>
      <div>
        <label>Select export format</label>
        <Dropdown
          options={formats}
          selectedItem={format}
          itemToString={i => i && i[0].toUpperCase() + i.slice(1)}
          onChange={setFormat}
          value={format}
        />
      </div>
      <div style={{ marginTop: 20, textAlign: 'right' }}>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button primary onClick={() => onOk(exportAll, format)}>
          Export
        </Button>
      </div>
    </div>
  )
}

EplExportModal.defaultProps = {
  hideButtons: true,
  showCloseIcon: true,
  shouldCloseOnOverlayClick: true,
  thinContent: true
}

export default EplExportModal
